"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system");
var _Spacer = _interopRequireDefault(require("../../Spacer"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Question = require("../../Test/Question.styled");
var _OrderingAnswer = require("../OrderingAnswer/OrderingAnswer");
var _GapAnswer = require("../GapAnswer/GapAnswer");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var McqAnswer = function McqAnswer(_ref) {
  var question = _ref.question,
    test = _ref.test,
    status = _ref.status;
  var isCorrect = (0, _react.useMemo)(function () {
    return question.correct;
  }, [question]);
  var showStudentAnswer = (0, _react.useMemo)(function () {
    return status === 'passed' && (test === null || test === void 0 ? void 0 : test.show_correct_if_passed) === false;
  }, []);
  var showCorrectAnswer = (0, _react.useMemo)(function () {
    return status === 'passed' && (test === null || test === void 0 ? void 0 : test.show_correct_if_passed) === true;
  }, []);
  var isStudentFailed = (0, _react.useMemo)(function () {
    return status === 'failed' && (test === null || test === void 0 ? void 0 : test.show_correct_if_failed) === false;
  }, []);
  var isStudentFailedRightAnswer = (0, _react.useMemo)(function () {
    return status === 'failed' && (test === null || test === void 0 ? void 0 : test.show_correct_if_failed) === true;
  }, []);
  var getMcqColor = function getMcqColor(item) {
    var _question$answer$cont, _question$answer$cont2;
    if (((_question$answer$cont = question.answer.content) === null || _question$answer$cont === void 0 ? void 0 : _question$answer$cont.options.answer) === item.choice) if ((_question$answer$cont2 = question.answer.content) !== null && _question$answer$cont2 !== void 0 && _question$answer$cont2.options.correct) return 'rgba(0, 214, 107, 0.1)';else return '#ffd5cc';
    if (showCorrectAnswer || isStudentFailedRightAnswer) if (item !== null && item !== void 0 && item.is_correct) return 'rgba(0, 214, 107, 0.1)';else return '';
    return '#FFF';
  };
  var bulletColor = function bulletColor(item) {
    var _question$answer$cont3, _question$answer$cont4;
    if (((_question$answer$cont3 = question.answer.content) === null || _question$answer$cont3 === void 0 ? void 0 : _question$answer$cont3.options.answer) === item.choice) if ((_question$answer$cont4 = question.answer.content) !== null && _question$answer$cont4 !== void 0 && _question$answer$cont4.options.correct) return 'green';else return 'lightRed';
    if (showCorrectAnswer || isStudentFailedRightAnswer) if (item !== null && item !== void 0 && item.is_correct) return 'green';else return 'silver';
    return 'silver';
  };
  var bulletState = function bulletState(item) {
    var _question$answer, _question$answer$cont5;
    if (((_question$answer = question.answer) === null || _question$answer === void 0 ? void 0 : (_question$answer$cont5 = _question$answer.content) === null || _question$answer$cont5 === void 0 ? void 0 : _question$answer$cont5.options.answer) === item.choice) return true;
    if (showCorrectAnswer || isStudentFailedRightAnswer) if (item !== null && item !== void 0 && item.is_correct) return true;else return false;
    return false;
  };
  return /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    p: {
      sm: '1rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Question.QuestionContentWrapper, {
    dangerouslySetInnerHTML: {
      __html: question.content
    }
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '0.813rem',
      lg: '2.313rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    px: {
      sm: '0.813rem'
    },
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(AnswersLabel, {
    fontSize: {
      sm: '0.5rem',
      lg: '1rem'
    },
    fontFamily: "Roboto"
  }, "Answers"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '6px',
      lg: '1rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    flexDirection: 'column'
  }, question.options.map(function (mcqItem, index) {
    return /*#__PURE__*/_react["default"].createElement(FlexLayoutStyle, {
      alignItems: 'center',
      key: "".concat(mcqItem, "-").concat(index),
      mb: {
        sm: '0.75rem'
      },
      background: getMcqColor(mcqItem)
    }, /*#__PURE__*/_react["default"].createElement(AnswerBullet, {
      filled: bulletState(mcqItem),
      state: bulletColor(mcqItem)
    }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
      mx: {
        sm: '4px'
      }
    }), /*#__PURE__*/_react["default"].createElement(_edSystem.Typography, {
      fontSize: {
        sm: '0.75rem',
        lg: '1.125rem'
      }
    }, /*#__PURE__*/_react["default"].createElement(Label, {
      htmlFor: mcqItem.choice
    }, mcqItem.choice)));
  }))), question.feedback !== null && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_OrderingAnswer.Text, null, "Feedback"), /*#__PURE__*/_react["default"].createElement(_GapAnswer.FeedbacktWrapper, {
    dangerouslySetInnerHTML: {
      __html: question.feedback
    }
  })));
};
var _default = McqAnswer;
exports["default"] = _default;
var FlexLayoutStyle = (0, _styledComponents["default"])(_edSystem.FlexLayout)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground: ", ";\n\theight: 2.313rem;\n\tpadding: 0.5rem;\n\tborder-radius: 7px;\n\tinput[type='radio']#correct {\n\t\taccent-color: #00d66b;\n\t}\n\tinput[type='radio']#wrong {\n\t\taccent-color: #ff0000;\n\t}\n"])), function (_ref2) {
  var background = _ref2.background;
  return background;
});
var Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfont-size: 0.75rem;\n\tcolor: rgba(0, 0, 0, 0.87);\n\tfont-weight: normal;\n\t@media screen and (min-width: 769px) {\n\t\tfont-size: 1.125rem;\n\t}\n"])));
var StyledRadioButton = _styledComponents["default"].input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 0.535rem;\n\theight: 0.535rem;\n\t@media screen and (min-width: 769px) {\n\t\twidth: 1.5rem;\n\t\theight: 1.5rem;\n\t}\n"])));
var AnswerBullet = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tborder-radius: 50%;\n\tposition: relative;\n\tbackground: ", ";\n\tbox-shadow: inset 0 0 0 1px #fff;\n\toutline: 1px solid\n\t\t", ";\n\twidth: 0.535rem;\n\theight: 0.535rem;\n\t@media screen and (min-width: 769px) {\n\t\twidth: 1.25rem;\n\t\theight: 1.25rem;\n\t\tbox-shadow: inset 0 0 0 3px #fff;\n\t}\n"])), function (props) {
  return props.filled ? props.theme.colors[props.state] : '';
}, function (props) {
  return props.filled ? props.theme.colors[props.state] : 'gray';
});
var AnswersLabel = (0, _styledComponents["default"])(_edSystem.Typography)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tcolor: ", ";\n\tfont-size: 1rem;\n\tfont-weight: 300;\n\t@media screen and (min-width: 769px) {\n\t\tmargin-bottom: 0.75rem;\n\t}\n"])), function (props) {
  return props.theme.colors.silver;
});